import React, { useState } from 'react';

export function CreateSocialPartnerScenarioModal({ onClose, onCreate }) {
  const [name, setName] = useState('');
  const [budget, setBudget] = useState('500,000');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      setError('Please enter a scenario name');
      return;
    }

    const budgetValue = parseInt(budget.replace(/,/g, ''));
    if (!budgetValue || budgetValue <= 0) {
      setError('Please enter a valid budget');
      return;
    }

    onCreate({
      id: `scenario_${Date.now()}`,
      name: name.trim(),
      client: 'Amazon Inc',  // These could be made editable in a future version
      brand: 'Prime Video',
      dateRange: 'Q4 2024',
      budget: `$${budgetValue.toLocaleString()}`,
      audience: {
        survey: 'Demo Survey',
        segment: 'Early adopters 35-44'
      }
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Create New Scenario</h2>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && <div className="error-message">{error}</div>}
            
            <div className="form-group">
              <label htmlFor="scenarioName">Scenario Name</label>
              <input
                type="text"
                id="scenarioName"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter scenario name"
                className="form-input"
                autoFocus
              />
            </div>

            <div className="form-group">
              <label htmlFor="scenarioBudget">Total Budget</label>
              <div className="budget-input-wrapper">
                <span className="budget-symbol">$</span>
                <input
                  type="text"
                  id="scenarioBudget"
                  value={budget}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setBudget(parseInt(value).toLocaleString());
                  }}
                  placeholder="Enter budget"
                  className="form-input"
                />
              </div>
            </div>
          </div>

          <div className="modal-actions">
            <button 
              type="button" 
              className="button-secondary" 
              onClick={onClose}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="button-primary"
            >
              Create Scenario
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 